// ------------------------------------
// FOTOS (CARROSSEL)
// ------------------------------------
$(function () {
  if ($(".produto-det-fotos").length) {
    const totalItens = $(".produto-det-foto").length;

    // Carrossel principal
    const $carouselMain = $(".produto-det-fotos");
    let carouselMainOpts = {
      type: "loop",
      perPage: 1,
      perMove: 1,
      speed: 600,
      arrows: true,
      pagination: true,
    };
    if (totalItens === 1) {
      carouselMainOpts.type = "slide";
      carouselMainOpts.arrows = false;
      carouselMainOpts.pagination = false;
      carouselMainOpts.drag = false;
      carouselMainOpts.keyboard = false;
    }
    let carouselMain = new Splide($carouselMain[0], carouselMainOpts);

    // Carrossel thumbs
    if (totalItens > 1) {
      const cols = {
        desktop: 5,
        tablet: 3,
        mobile: 4,
      };
      const $carouselThumbs = $(".produto-det-thumbs");

      const totalThumbs = $(".produto-det-thumbs").length;
      let activeArrows = totalThumbs > 5 ? true : false;
      console.log(activeArrows);

      let carouselThumbsOpts = {
        type: "slide",
        perPage: cols.desktop,
        gap: "16px",
        arrows: activeArrows,
        pagination: false,
        rewind: true,
        isNavigation: true,
        dragMinThreshold: {
          mouse: 4,
          touch: 10,
        },
        breakpoints: {
          // Tablet
          1200: {
            perPage: cols.tablet,
          },
          // Mobile
          760: {
            perPage: cols.mobile,
            arrows: false,
          },
        },
      };
      // Ajuste para quando houver menos itens do que a quantidade por página do carrossel (Centraliza)
      if (
        (isMedia("desktop") && totalItens < cols.desktop) ||
        (isMedia("tablet") && totalItens < cols.tablet) ||
        (isMedia("mobile") && totalItens < cols.mobile)
      ) {
        $carouselThumbs.addClass("carousel-force-center");
        carouselThumbsOpts.arrows = false;
        carouselThumbsOpts.drag = false;
        carouselThumbsOpts.keyboard = false;
      }
      let carouselThumbs = new Splide($carouselThumbs[0], carouselThumbsOpts);
      carouselMain.sync(carouselThumbs);
      carouselMain.mount();
      carouselThumbs.mount();
    } else {
      carouselMain.mount();
    }
  }
});

// ------------------------------------
// Zoom
// ------------------------------------
(function () {
  "use strict";
  const enableZoom =
    $(".produto-det-fotos").data("zoom-hover") && $(window).width() > 960;
  if (enableZoom) {
    $(".produto-det-foto").each(function () {
      const $el = $(this);
      const imgLg = $(this).attr("href");
      if (imgLg) {
        $el.zoom({
          url: imgLg,
        });
      }
    });
  }
})();
